// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"snCUF","toggleButton":"_21fES","hideMobile":"_1pqKi","active":"_3u-gD"};